import React from 'react';

// Renders a cover image honouring the admin-chosen focal point + zoom
const FocusImage = ({ src, alt, focus, className = '', imgClassName = '', ...rest }) => {
  const f = { x: 50, y: 50, zoom: 1, ...(focus || {}) };
  return (
    <div className={`overflow-hidden ${className}`} {...rest}>
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${imgClassName}`}
        style={{ objectPosition: `${f.x}% ${f.y}%`, transform: `scale(${f.zoom})`, transformOrigin: `${f.x}% ${f.y}%` }}
      />
    </div>
  );
};

export default FocusImage;
